const initialState = (values) => ({
	step: 0,
	values: [
		{
			firstName: values?.firstName,
			lastName: values?.lastName,
			email: values?.email,
			legalBusinessName: '',
			mobilePhone: '',
			dealershipName: '',
			hasUSLicense: '',
			businessType: '',
			auctionAccessDealerId: '',
			recaptcha: '',
			legalEntityTypes: '',
			stateTaxId: '',
			driverLicenseFile: null,
			marketplace_document_ids: [],
		},
		{
			dealershipAge: '',
			vehiclesSoldMonthly: '',
			jobFunction: '',
			jobFunctionDescription: '',
			dealershipAddress: '',
			dealershipAddress2: '',
			city: '',
			state: '',
			zip: '',
			dealershipPhone: '',
			latitude: '',
			longitude: '',
		},
		{
			dealerLicenseFile: null,
			driverLicenseFile: null,
			taxID: '',
		},
		{
			password: '',
			passwordConfirmation: '',
		},
	],
	token: values?.token,
	loadedPartialData: false,
	resumeStep: -1,
	backButtonClicked: false,
	error: '',
});

export default initialState;
